import { render, staticRenderFns } from "./Adminka.vue?vue&type=template&id=661ccc05&scoped=true&"
import script from "./Adminka.vue?vue&type=script&lang=js&"
export * from "./Adminka.vue?vue&type=script&lang=js&"
import style0 from "./Adminka.vue?vue&type=style&index=0&id=661ccc05&scoped=true&lang=scss&"
import style1 from "./Adminka.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661ccc05",
  null
  
)

export default component.exports